module.exports = __webpack_public_path__ + "static/images/wx-erweima.1601450.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wx-erweima.jpg
// module id = 0fjS
// module chunks = 1